<div *ngIf="supplierId" class="card mt-2">
    <div *ngIf="loading" class="d-flex justify-content-center">
        <H5 class="text-warning my-5">Chargement en cours...</H5>
    </div>
    <div *ngIf="!loading" class="card-body">
        
        <div class="row">
            <div class="col-6 offset-3 mt-2">
                <table class="table-criticite" style="width:100%;">
                    <thead>
                        <tr class="text-center">
                            <th></th>
                            <th>Criticité</th>
                            <th>Détail</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr *ngFor="let item of indicateurs">
                            <td > <label class="control-label ml-2">{{item.IndicateurLib}}</label></td>
                            <td >
                                <div class="d-flex justify-content-center">
                                    <div class="indicateur" [ngClass]="indicateurClass(item.Cod)"></div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex flex-column ml-1">
                                    <div *ngFor="let line of detailLines(item)">
                                        {{line}}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>